// Saved Studio angles remain clockwise from above. Photoshop authoring uses
// counterclockwise angles from the right; adapt only at the UI boundary.
export const toStudioLightDirection = (angle) =>
  (((90 - angle) % 360) + 360) % 360;

export const normalizePhotoshopLightAngle = (angle) => {
  const wrapped = ((angle % 360) + 360) % 360;
  return wrapped > 180 ? wrapped - 360 : wrapped;
};

export const toPhotoshopLightAngle = (direction) =>
  normalizePhotoshopLightAngle(90 - direction);
